/* ==========================================================================
   LUNÉA COSMETICS — Land- en taalpopup (v3.26.0)
   Zie snippets/lunea-geo.liquid voor de werking.
   Vanilla JS, geen afhankelijkheden. Faalt stil: geen popup als iets ontbreekt.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__luneaGeo) return;
  window.__luneaGeo = true;

  var cfgEl = document.getElementById('lunea-geo-config');
  var root = document.getElementById('lunea-geo');
  var form = document.getElementById('LuneaGeoForm');
  if (!cfgEl || !root || !form) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var KEY = 'lunea:geo:gekozen';
  var PAUZE = 30 * 24 * 60 * 60 * 1000; // 30 dagen
  var TALEN = ['nl', 'fr', 'de'];             // talen waarin de popup kan praten

  /* ---- Opslag (try/catch: privémodus, geblokkeerde cookies) ---- */
  function lees() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); return v && v.t ? v : null; } catch (e) { return null; }
  }
  function bewaar(keuze) {
    try { localStorage.setItem(KEY, JSON.stringify({ k: keuze, t: Date.now() })); } catch (e) {}
  }
  /* Testen: ?geo=FR doet alsof de bezoeker uit Frankrijk komt (en negeert een eerdere keuze) */
  var test = (location.search.match(/[?&]geo=([A-Za-z]{2})/) || [])[1];

  var eerder = lees();
  if (!test && eerder && Date.now() - eerder.t < PAUZE) return;

  /* ---- Teksten (vous in het Frans) ---- */
  var LANDEN = {
    nl: { BE: 'België', FR: 'Frankrijk', NL: 'Nederland', DE: 'Duitsland', LU: 'Luxemburg' },
    fr: { BE: 'Belgique', FR: 'France', NL: 'Pays-Bas', DE: 'Allemagne', LU: 'Luxembourg' },
    de: { BE: 'Belgien', FR: 'Frankreich', NL: 'die Niederlande', DE: 'Deutschland', LU: 'Luxemburg' }
  };
  var IN_LAND_FR = { BE: 'en Belgique', FR: 'en France', NL: 'aux Pays-Bas', DE: 'en Allemagne', LU: 'au Luxembourg' };

  var T = {
    nl: {
      eyebrow: 'Land en taal',
      landTitel: function (l) { return 'Bezoek je ons vanuit ' + l + '?'; },
      landTekst: function (l) { return 'Shop in de winkel voor ' + l + '. Dan kloppen de verzendkosten, levertijden en betaalmethodes voor jouw land.'; },
      naarLand: function (l) { return 'Naar de winkel voor ' + l; },
      blijfLand: function (l) { return 'Blijf op de winkel voor ' + l; },
      taalTitel: function () { return 'Bekijk de winkel in het Nederlands?'; },
      taalTekst: function () { return 'Deze pagina staat in het Frans. Je kan altijd van taal wisselen bovenaan de pagina.'; },
      naarTaal: function () { return 'Naar het Nederlands'; },
      blijfTaal: function () { return 'Blijf in het Frans'; },
      ander: 'Ander land kiezen',
      kies: 'Kies je land',
      ok: 'Bevestigen',
      sluit: 'Sluiten'
    },
    fr: {
      eyebrow: 'Pays et langue',
      landTitel: function (l, c) { return 'Vous êtes ' + (IN_LAND_FR[c] || ('en ' + l)) + ' ?'; },
      landTekst: function (l) { return 'Achetez sur notre boutique ' + l + ' : les frais de port, les délais de livraison et les moyens de paiement seront adaptés à votre pays.'; },
      naarLand: function (l) { return 'Aller sur la boutique ' + l; },
      blijfLand: function (l) { return 'Rester sur la boutique ' + l; },
      taalTitel: function () { return 'Voir la boutique en français ?'; },
      taalTekst: function () { return 'Cette page est affichée en néerlandais. Vous pouvez changer de langue à tout moment en haut de la page.'; },
      naarTaal: function () { return 'Passer au français'; },
      blijfTaal: function () { return 'Rester en néerlandais'; },
      ander: 'Choisir un autre pays',
      kies: 'Choisissez votre pays',
      ok: 'Confirmer',
      sluit: 'Fermer'
    },
    de: {
      eyebrow: 'Land und Sprache',
      landTitel: function (l, c) { return c === 'NL' ? 'Sind Sie in den Niederlanden?' : 'Sind Sie in ' + l + '?'; },
      landTekst: function () { return 'Kaufen Sie in unserem Shop für Ihr Land ein: Versandkosten, Lieferzeiten und Zahlungsarten passen dann zu Ihrem Land.'; },
      naarLand: function (l) { return 'Zum Shop für ' + l; },
      blijfLand: function (l) { return 'Im Shop für ' + l + ' bleiben'; },
      taalTitel: function () { return 'Den Shop auf Deutsch ansehen?'; },
      taalTekst: function () { return 'Diese Seite ist in einer anderen Sprache. Sie können die Sprache jederzeit oben auf der Seite wechseln.'; },
      naarTaal: function () { return 'Auf Deutsch wechseln'; },
      blijfTaal: function () { return 'In dieser Sprache bleiben'; },
      ander: 'Anderes Land wählen',
      kies: 'Wählen Sie Ihr Land',
      ok: 'Bestätigen',
      sluit: 'Schließen'
    }
  };

  function browserTaal() {
    var list = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']);
    for (var i = 0; i < list.length; i++) {
      var l = String(list[i] || '').slice(0, 2).toLowerCase();
      if (TALEN.indexOf(l) !== -1) return l;
    }
    return null;
  }

  /* Taal die bij een land hoort: browsertaal als we die hebben, anders de hoofdtaal van het land */
  function taalVoor(land) {
    var b = browserTaal();
    if (b) return b;
    return land === 'FR' || land === 'LU' ? 'fr' : land === 'DE' ? 'de' : 'nl';
  }

  function landNaam(code, taal) { return (LANDEN[taal] && LANDEN[taal][code]) || code; }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---- Bepalen wat we voorstellen ---- */
  function bepaal(gedetecteerd) {
    var huidig = cfg.country;
    if (!gedetecteerd) return null;

    // 1. Ander land en we leveren daar → land voorstellen
    if (gedetecteerd !== huidig && cfg.countries.indexOf(gedetecteerd) !== -1) {
      return { soort: 'land', land: gedetecteerd, taal: taalVoor(gedetecteerd) };
    }
    // 2. Zelfde land, andere browsertaal die op deze markt bestaat → taal voorstellen
    if (gedetecteerd === huidig) {
      var b = browserTaal();
      if (b && b !== cfg.lang && cfg.languages.indexOf(b) !== -1) {
        return { soort: 'taal', land: huidig, taal: b };
      }
    }
    return null;
  }

  /* ---- Versturen via het localization-formulier van Shopify ---- */
  function kies(land, taal, bewaarKeuze) {
    bewaar(bewaarKeuze || 'gewisseld');
    form.elements.country_code.value = land;
    form.elements.locale_code.value = taal;
    form.submit();
  }

  /* ---- Popup tonen ---- */
  var vorigeFocus = null;

  function toon(v) {
    var taal = v.taal;           // de popup praat de taal die de bezoeker leest
    var t = T[taal] || T.nl;
    var doel = landNaam(v.land, taal);
    var hier = landNaam(cfg.country, taal);
    var vlag = cfg.flags && cfg.flags[v.land];

    var titel = v.soort === 'land' ? t.landTitel(doel, v.land) : t.taalTitel();
    var tekst = v.soort === 'land' ? t.landTekst(doel, v.land) : t.taalTekst();
    var ja = v.soort === 'land' ? t.naarLand(doel, v.land) : t.naarTaal();
    var nee = v.soort === 'land' ? t.blijfLand(hier, cfg.country) : t.blijfTaal();

    var opties = cfg.countries.map(function (c) {
      return '<option value="' + esc(c) + '"' + (c === v.land ? ' selected' : '') + '>' + esc(landNaam(c, taal)) + '</option>';
    }).join('');

    var box = document.createElement('div');
    box.className = 'lgeo__overlay';
    box.innerHTML =
      '<div class="lgeo__card" role="dialog" aria-modal="true" aria-labelledby="lgeo-title" aria-describedby="lgeo-text" lang="' + esc(taal) + '" tabindex="-1">' +
        '<button type="button" class="lgeo__close" data-lgeo-close aria-label="' + esc(t.sluit) + '">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<p class="lu-eyebrow lgeo__eyebrow">' + esc(t.eyebrow) + '</p>' +
        '<div class="lgeo__head">' +
          (vlag ? '<img class="lgeo__flag" src="' + esc(vlag) + '" alt="" width="36" height="27">' : '') +
          '<h2 class="lgeo__title" id="lgeo-title">' + esc(titel) + '</h2>' +
        '</div>' +
        '<p class="lgeo__text" id="lgeo-text">' + esc(tekst) + '</p>' +
        '<div class="lgeo__actions">' +
          '<button type="button" class="lu-btn lu-btn--primary lu-btn--block" data-lgeo-ja>' + esc(ja) + '</button>' +
          '<button type="button" class="lu-btn lu-btn--ghost lu-btn--block" data-lgeo-nee>' + esc(nee) + '</button>' +
        '</div>' +
        (cfg.countries.length > 2 && v.soort === 'land'
          ? '<details class="lgeo__other"><summary>' + esc(t.ander) + '</summary>' +
              '<div class="lgeo__pick"><label class="lgeo__sr" for="lgeo-select">' + esc(t.kies) + '</label>' +
              '<select id="lgeo-select" class="lgeo__select">' + opties + '</select>' +
              '<button type="button" class="lu-btn lu-btn--outline lu-btn--sm" data-lgeo-pick>' + esc(t.ok) + '</button></div>' +
            '</details>'
          : '') +
      '</div>';

    root.appendChild(box);
    root.hidden = false;
    vorigeFocus = document.activeElement;
    document.documentElement.classList.add('lgeo-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    var card = box.querySelector('.lgeo__card');
    setTimeout(function () { var b = box.querySelector('[data-lgeo-ja]'); (b || card).focus(); }, 60);

    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('[data-lgeo-close]') || e.target.closest('[data-lgeo-nee]')) { sluit(); return; }
      if (e.target.closest('[data-lgeo-ja]')) { kies(v.land, v.taal, v.soort === 'land' ? 'land:' + v.land : 'taal:' + v.taal); return; }
      if (e.target.closest('[data-lgeo-pick]')) {
        var c = box.querySelector('#lgeo-select').value;
        if (c === cfg.country) { sluit(); return; }
        kies(c, taalVoor(c), 'land:' + c);
      }
    });

    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); sluit(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(card.querySelectorAll('button, select, summary, [href]'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function sluit() {
    bewaar('gebleven');
    root.classList.remove('is-open');
    document.documentElement.classList.remove('lgeo-open');
    setTimeout(function () { root.hidden = true; root.querySelectorAll('.lgeo__overlay').forEach(function (n) { n.remove(); }); }, 250);
    if (vorigeFocus && vorigeFocus.focus) { try { vorigeFocus.focus(); } catch (e) {} }
  }

  /* ---- Start ---- */
  function start() {
    if (test) { var v0 = bepaal(test.toUpperCase()); if (v0) toon(v0); return; }

    var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') +
      'browsing_context_suggestions.json?country%5Benabled%5D=true&country%5Bexclude%5D=' + encodeURIComponent(cfg.country) +
      '&language%5Benabled%5D=true&language%5Bexclude%5D=' + encodeURIComponent(cfg.lang);

    fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var land = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        var v = bepaal(land ? String(land).toUpperCase() : null);
        if (v) toon(v);
      })
      .catch(function () { /* stil falen */ });
  }

  var wacht = Math.max(0, Number(cfg.delay) || 0) * 1000;
  if (document.readyState === 'complete') setTimeout(start, wacht);
  else window.addEventListener('load', function () { setTimeout(start, wacht); });
})();
